const inlineMenu = document.querySelector(".header__inline-menu");
const detailsItems = inlineMenu.querySelectorAll("details");
detailsItems.forEach(item => {
  const ulElement = item.querySelector("ul");
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    ulElement.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});
const anchors = document.querySelectorAll('.menu-second .mega-menu__list .list-unstyled li a');
anchors.forEach(anchor => {
  anchor.addEventListener('mouseover', function() {
    const datatitle = anchor.getAttribute('data-title');
    const parentMenu = $(this).parents('.menu-second');
    parentMenu.children('a').hide();
    const matchingAnchor = parentMenu.children(`a[data-title="${datatitle}"]`);
    if (matchingAnchor.length > 0) {
      matchingAnchor.show();
    } else {
      parentMenu.children('a').first().show();
    }
  });
});
$(document).ready(function() {
   $(document).on('click', '.button1', function(event) {
   event.preventDefault();
      $(this).parents('.gallery-slide').find('.popup-o').addClass('active_popup'); // Replace 'your-new-class' with the class you want to add
     $('.slider-single, .slider-nav').each(function() {
     $(this).slick('refresh');
   });
    
   var numSlides = $(this).parents('.gallery-slide').find('.popup-o .mlt-gal-btm .m-gallery-img').length;  
   if(parseInt(numSlides) < 2){
     $(this).parents('.gallery-slide').find('.popup-o .mlt-gal-btm').hide();
   }
   else{
     $(this).parents('.gallery-slide').find('.popup-o .mlt-gal-btm').show();
   }
     
 });
 $(".btn-close").click(function() {
  
      $(".popup-o").removeClass('active_popup'); // Replace 'your-new-class' with the class you want to add

   $(this).parents('.multi-img-galery').find('.slider-single').slick('refresh');
   $(this).parents('.multi-img-galery').find('.mlt-gal-btm').children('.slider-nav').slick('slickGoTo', 0);
 });
 });


$(document).ready(function(){
    $(".slider-single").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay : false,
  arrows: false,
  fade: true,
      variableWidth: false,
  useTransform: true,
        adaptiveHeight: true,

  asNavFor: ".slider-nav"
});
$(".slider-nav").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay : false,
  prevArrow:"<div class='a-left control-c prev slick-prev'><img  src='https://cdn.shopify.com/s/files/1/0868/0158/0332/files/Vector_47.svg?v=1713168052'></div>",
  nextArrow:"<div class='a-right control-c next slick-next'><img  src='https://cdn.shopify.com/s/files/1/0868/0158/0332/files/Vector_46.svg?v=1713168052'></div>",
  asNavFor: ".slider-single",
  dots: false,
  focusOnSelect: true,
});
});

$(document).on('click', '.active_popup', function(){
 $(this).find(".btn-close").trigger('click');
});
$(document).on('click', '.popup_wrap', function(e){
   e.stopPropagation();
});

// Show the first four images 3499 .gallery-slide
$(".gallery-slide:lt(10)").show();

// When the gallery button is clicked
 $("#gallery-btn").on('click', function(event) {
   // Prevent default behavior
  event.preventDefault();
  // All of the hidden images
   var $hidden = $(".gallery-slide:hidden");
   // Show the next four images
   $($hidden).slice(0, 4).fadeIn(800);
   // If the length of $hidden is 4 then hide the button
   if ($hidden.length == 4) {
     $(this).fadeOut();
   }
 });
$(document).ready(function() {
  $(document).on('click', '#CartDrawer-Overlay' , function() {
       $('.drawer').removeClass('active');
       $('body').removeClass(' overflow-hidden');
  });
  $('.changeformat:not(.changeformat-done)').each(function() {
     $(this).addClass("changeformat-done"); 
    var text = $(this).text();
    var numberPattern = /\d+/g; // Regular expression to match all numbers
    
    var formattedText = text.replace(numberPattern, function(match) {
      var formattedNumber = parseInt(match).toLocaleString('en-US'); // Format the matched number
      return formattedNumber; // Return the formatted number to replace in the text
    });
    
    $(this).text(formattedText); // Update the text content of the element
  });
});

$(document).ready(function(){
    $('.focusable_sec_item').on("click",function(event){
        // Prevent default behavior
        event.preventDefault();
        
        // Get the href attribute value
        var href = $(this).attr('href');
        console.log(href);
        // Check if the href contains a '#'
        if(href.indexOf('#') !== -1){
            // Get the target element's ID
            var targetId = href.split('#')[1];
            var $targetElement = $('#' + targetId);
            
            // Check if the target element exists
            if($targetElement.length){
                // Animate scrolling to the target element
                $('html, body').animate({
                    scrollTop: $targetElement.offset().top
                }, 1000); // Adjust the animation duration as needed
            }
        } else {
            // Redirect to the URL
            window.location.href = href;
        }
    });
});

